(function () {
  /* fx-failsafe: nigdy nie zostawiaj treści ukrytej */
  setTimeout(function () { document.querySelectorAll('.fx-reveal:not(.is-visible)').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight) el.classList.add('is-visible'); }); }, 2500);
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.fx-reveal').forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  function scan(root) { (root || document).querySelectorAll('.fx-reveal:not(.is-visible)').forEach(function (el) { io.observe(el); }); }
  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
